import { classNames } from "@deathstar/ui";

export default function Title({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
    return <p className={classNames("text-3xl font-bold tracking-wide text-navigator-primary-dark", className)} {...props} />;
}
